import { mediaItems, indexItems } from '@/mocks/homeMangaData';

export function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">阅读体验</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            咻咻漫画独创下拉式阅读模式，带来前所未有的畅快追漫体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-48 md:h-52 object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  width="400"
                  height="225"
                  onError={(e) => {
                    const t = e.currentTarget;
                    t.style.display = 'none';
                    (t.parentElement as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-background-50/90 backdrop-blur-sm rounded-full text-xs font-medium text-foreground-700">
                    <i className={`${item.icon} text-primary-500`}></i>
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function IndexSection() {
  const scrollTo = (anchor: string) => {
    const el = document.querySelector(anchor);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">专题索引</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            八大漫画品类全覆盖，韩漫国漫日漫随心选，点击即可开启全集畅读之旅
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#cards"
              onClick={(e) => { e.preventDefault(); scrollTo('#cards'); }}
              className={`group ${item.color} rounded-xl p-4 md:p-5 border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer`}
            >
              <div className="w-full h-32 md:h-36 rounded-lg overflow-hidden mb-3">
                <img
                  src={item.image}
                  alt={`${item.title} - ${item.desc}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  width="200"
                  height="150"
                  onError={(e) => {
                    const t = e.currentTarget;
                    t.style.display = 'none';
                    (t.parentElement as HTMLElement).style.display = 'none';
                  }}
                />
              </div>
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-1">{item.title}</h3>
              <p className="text-xs text-foreground-500 mb-2">{item.desc}</p>
              <span className="inline-block text-xs font-semibold text-primary-600 bg-primary-100 px-2.5 py-0.5 rounded-full">
                {item.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export default function MediaIndexSection() {
  return (
    <>
      <MediaSection />
      <IndexSection />
    </>
  );
}